<template>
  <div class="chapterOne">
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第2章 AI问题求解（4 探索和问题求解）</div>
      <div style="marginTop:30px;fontSize:12px;color:rgb(153,153,153);">2020-3-14 20:12:32</div>
      <div class="text fontBig" style="marginTop:70px;">搜索算法不一定是一种很酷的AI方法，但它们可以被用来解决我们大多数人都承认需要智能的任务，比如导航或下棋。</div>
      <div class="text fontBig">在第2章，我们将介绍以下几个部分。</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;" @click="jumpOne">一、<span style="color:#0090ff;textDecoration:underline;">搜索和问题求解</span>（0/2）</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;"  @click="jumpTow">二、<span style="color:#0090ff;textDecoration:underline;">用AI解决问题</span>（---）</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;" @click="jumpThree">三、<span style="color:#0090ff;textDecoration:underline;">搜索和游戏</span>（0/1）</div>
      <div  id="productId"><div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第1节 探索和问题求解</div></div>
      <div class="text fontBig" style="marginTop:70px;">许多问题可以表述为搜索问题。这类问题往往要求我们，从一开始就要尝试制定备选方案，并且估计可能产生的后果。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">一、搜索实践：从A到B</div>
      <div class="text fontBig">想象一下，您在国外的某个城市的某个地点（例如酒店），并且想使用公共交通工具到达另一个地点（也许是一家不错的餐厅）。您会做什么呢？也许您会和很多人一样，拿出智能手机，输入目的地，然后按照指示进行操作，如图1所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-01.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图1 使用智能手机导航</div>
      <div class="text fontBig">该问题属于搜索和规划问题的范畴。无人驾驶汽车和应用AI的游戏（也许不太明显）也有类似的问题，例如，在国际象棋游戏中，就有将棋子从A到B移动的问题。当然，在应用AI的游戏中，移动一颗棋子的难度并不是很大，难的是如何使棋子尽量不受对方伤害并保证全局能赢，这中间就要考虑很多的部署了，如图2所示</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-02.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图2 实现目标需要经过许多部署</div>
      <div class="text fontBig">通常，有许多不同的方法可以解决这类问题，其中某些方法，相较于从时间、精力、成本或其他因素来考虑，可能更可取，简单地如图3所示。不同的搜索技术可能导致不同的解决方案，开发更优的搜索算法自然成为研究的重点。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-03.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图3 多种解决问题的途径</div>
      <div class="text fontBig">这里，我们不关注真实的搜索算法，而只将重点放在问题解决过程的第一阶段：明确选择及其产生的后果，这通常并非易事，而必须仔细考虑。我们还需要明确我们的目标是什么，换句话说，什么时候我们可以解决问题。完成此操作后，我们就可以找到从初始状态到目标状态的一系列动作。</div>
      <div class="text fontBig">在本章中，我们将讨论两种问题：</div>
      <ul>
        <li class="text fontBig">在只有一个“代理人”的静态环境中的搜索和规划</li>
        <li class="text fontBig">有两个玩家（“代理人”）相互竞争的游戏</li>
      </ul>
      <div class="text fontBig">这些类别的问题并未涵盖所有可能的现实情况，但它们足够通用，足以演示主要的概念和技术。</div>
      <div class="text fontBig">在我们处理诸如导航或下棋之类的复杂搜索任务之前，让我们从一个非常简化的模型开始，以建立我们对如何通过AI解决问题的理解。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">二、玩具问题：鸡过河</div>
      <div class="text fontBig">我们将从一个简单的智力游戏开始说明这些想法。机器人需要通过划艇移动三个对象过河：一只狐狸，一只鸡和一袋鸡饲料。如果有机会，狐狸就会吃鸡，如果有机会，鸡就会吃鸡饲料，两者都不是可取的结果。当然，机器人在场就能防止鸡或食品受到伤害，但前提是只有机器人可以操作划艇，划艇上也只能装下两个对象和机器人一起。如图4所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-04.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图4 鸡过河游戏</div>
      <div class="text fontBig">机器人怎样才能将所有对象都移至河的对岸呢？</div>
      <div class="text fontBig" style="fontWeight:bold">1. 划艇之谜的简易版</div>
      <div class="text fontBig">如果您以前听过这个智力游戏，您可能会知道即使划艇的空间更小，那样的谜题也可以解决。现在，我们要解决的这个划艇之谜只是简易版，可算是您对那更难的划艇之谜的一次练习。</div>
      <div class="text fontBig">我们以五个可移动的对象来模拟这个谜题：机器人，划艇，狐狸，鸡和鸡饲料。原则上，这五者中的每一个都可以在河的两边，但由于只有机器人才能操作划艇，因此总有剩下的两者会位于河的同一边。这样，就有四个情况，每种情况都有两个可能的位置，从而构成了16种组合，我们将其称为状态，如表1所示。</div>
      <div class="text fontBig" style="textAlign:center;">表1 鸡过河之谜的16种状态</div>
      <img style="width:300px;marginLeft:200px" src="../assets/04-13.png" alt="">
      <div class="text fontBig">我们给各状态起了简短的名字，以便讨论起来比较方便。现在我们可以简单地说起始状态为NNNN，目标状态为FFFF，而不是类似“在起始状态下，机器人在近侧，狐狸在近侧，鸡在近侧，鸡饲料也在近侧，而在目标状态下，机器人在远侧”那么麻烦，依此类推。</div>
      <div class="text fontBig" style="fontWeight:bold">1. 鸡过河游戏的允许状态</div>
      <div class="text fontBig">鸡过河游戏的条件是必须禁止其中的某些状态。例如，在状态NFFN（意味着机器人和鸡饲料在一边，而狐狸和鸡在另一边），狐狸会吃掉我们吃不了的那只鸡。因此，我们可以排除这几个状态：NFFN，NFFF，FNNF，FNNN，NNFF和FFNN（如果您怀疑我们的推理，可以检查每个状态）。这样，就只剩下以下10个允许状态，如表2所示。</div>
      <div class="text fontBig" style="textAlign:center;">表2 鸡过河之谜的10种状态</div>
      <img style="width:300px;marginLeft:200px" src="../assets/04-14.png" alt="">
      <div class="text fontBig" style="fontWeight:bold">3. 鸡过河游戏的图示</div>
      <div class="text fontBig">接下来，我们要找出哪些状态转换是可能的，也就是说，当机器人将载有某些对象作为货物划船渡河时，在每种情况下得到的状态是什么。最好绘制一个转换图，因为在任何一次转换中，近（N）和远（F）总在交替转换，因此可以方便地将以N开头的状态（机器人在近侧）绘制成一行，而在另一行绘制以F开头的状态，如图5所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-05.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图5 鸡过河游戏的状态图</div>
      <div class="text fontBig">现在让我们绘制转换线。我们可以画一个箭头使它们从一个节点指向另一个节点，但在这个谜题中，转换是对称的：如果机器人可以从状态NNNN这一边到状态FFFF，它同样可以从另一个方向由FNFF变到NNNN。因此，仅使用没有方向的线来绘制转换会更简单。从NNNN开始，我们可以转到FNFN、FNFF、FFNF和FFFN，如图6所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-06.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图6 鸡过河游戏的状态变化</div>
      <div class="text fontBig">然后，我们可以补充画出其余可能发生的状态变化，变成完整的状态变化图，如图7所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-07.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图7 鸡过河游戏的状态变化全图</div>
      <div class="text fontBig">至此，我们在鸡过河游戏上做了很多工作，似乎还没有找到解决方法，毫无疑问，您完全可以通过使用你的“天然智商”来解决这个谜题。但是对于更复杂的问题，在可能的解决方案数量成千上万增长的情况下，我们要去解决起来就很费力，这样的复杂问题用系统或机械方法来处理将大放异彩，因为对于我们感到困难的部分却是很适合由计算机去做。既然我们已经制定了可选状态和它们之间的状态变化，剩下的就变成了一项机械任务：找到从初始状态NNNN到最终状态FFFF的路径。</div>
      <div class="text fontBig">可行路径很多，这里画出其中一条：首先，从NNNN到FFFN（机器人将狐狸和鸡带到河的另一边），然后，返回到NFNN（机器人带着鸡回到起始端），最后，抵达FFFF（机器人现在可以带着小鸡和鸡饲料渡河到另一边了），如图8所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-08.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图8 鸡过河游戏的一条路径</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">4. 状态空间、转换和成本</div>
      <div class="text fontBig">为了形式化规划问题，我们使用诸如状态空间、转换和成本之类的概念。</div>
      <div class="text fontBig" style="color:#0090ff;">【关键术语】</div>
      <div class="text fontBig" style="color:#0090ff;"><b>（1）状态空间</b></div>
      <div class="text fontBig" style="color:#0090ff;">表示一系列可能的情况。在鸡过河的谜题中，状态空间包括从NNFF到FFFF的10个允许状态（但不包括NFFF，这是谜题规则所不允许的）。如果任务是从位置A导航到位置B，则状态空间可以是由它们的（x，y）坐标定义的位置集合，可以从起点A到达这些位置。或者我们可以使用一组约束位置，例如不同的街道地址，以便限制可能的状态数。</div>
      <div class="text fontBig" style="color:#0090ff;"><b>（2）转换</b></div>
      <div class="text fontBig" style="color:#0090ff;">一种状态与另一种状态之间可能的移动，例如NNNN到FNFN。需要注意的是，我们仅将可以通过单个操作完成的直接转换算作转换。从A到C，从C到D以及从D到B（目标）的多个转换序列是一条路径而不是转换。</div>
      <div class="text fontBig" style="color:#0090ff;"><b>（3）成本</b></div>
      <div class="text fontBig" style="color:#0090ff;">指的是这样一个事实，即通常情况下不同的转换并不完全相同。它们可以在某些方面有所不同，从而使某些转换更可取或更便宜（不一定是货币意义上的便宜），而另一些则更昂贵。我们可以通过与每个转换关联到一定的成本来表达这一点。如果目标是使总行驶距离最小化，那么自然成本就是状态之间的地理距离。另一方面，目标实际上可能是最小化时间而不是距离，在这种情况下，自然成本显然就应是时间。如果所有转换都相等，那么我们可以忽略成本。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">【知识巩固】</div>
      <div class="text fontBig"><b>练习5：较少的划艇数 </b>Ref/7 : NNNN -> FNFN -> NNFN -> FFFN -> NFNN -> FFNF -> NFNF -> FFFF, 或 NNNN -> FNFN -> NNFN -> FNFF -> NNNF -> FFNF -> NFNF -> FFFF）</div>
      <div class="text fontBig">在这谜题的传统版本中，机器人只能将一个对象放在船上。状态空间仍然相同，但是可能的转换次数要求较少。</div>
      <div class="text fontBig">使用下面10个可能状态的图表作为起点，在其中绘制可能的转换（使用铅笔和纸比不使用铅笔和纸更容易做到这一点）。如图9所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-09.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图9 鸡过河的10种状态</div>
      <div class="text fontBig">绘制状态转换图后，找到从NNNN到FFFF的最短路径，并计算其上的转换次数。</div>
      <div class="text fontBig">请输入您的答案作为最短路径中的转换数（仅输入一个数字，例如“12”）。提示：不计算状态数，而是计算转换数。例如，路径NNNN→FFNF→NFNF→FFFF中的转换数为3，而不是4。</div>
      <div class="text fontBig" style="textAlign:center;">您的答案是：<input type="text" class="anwserInput" :disabled="contenteditable"></div>
      <button class="sentBtn" style="marginLeft:290px;" @click="sentBtnOne">提交</button>
      <div class="text fontBig"><b>练习6：河内塔</b>（Ref/1E，2B，3F，4D，5C，6F）</div>
      <div class="text fontBig">让我们再做一个难题：著名的河内塔。在我们的版本中，拼图涉及三个栓钉和两个圆盘：一个大圆盘和一个小圆盘（实际上，可以有任意数量的圆盘，但对于练习而言，两个足以证明其原理）。</div>
      <div class="text fontBig">在初始状态下，两个圆盘都堆叠在第一个（最左侧）栓钉中。目的是将圆盘移动到第三钉。您可以一次将一个圆盘从任何一个钉移到另一个钉，只要它上面没有其他圆盘。不允许将较大的圆盘放在较小的圆盘上。如图10所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-10.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图10 河内塔的初始状态和目标状态</div>
      <div class="text fontBig">此图显示了初始状态和目标状态。还有七个其他状态，因此可能状态的总数为九个：放置大圆盘的三种方式，对于每种方式，又有三种放置小圆盘的方式。9种可能状态如图11所示。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-11.png" alt="">
      <div class="text fontBig" style="textAlign:center;">图11 河内塔的9种可能状态</div>
      <div class="text fontBig">您的任务：绘制状态图。该图应包括游戏中的所有九种可能状态，并用表示可能转变的线连接起来。图11显示了状态图的整体结构以及前三个状态的位置。它显示了从开始状态（在顶部角落），您可以通过移动小圆盘来移动到其他两个状态。通过将其余状态放在正确的位置来完成状态图。请注意，转换还是对称的，您也可以在图中向侧面（左侧或右侧）或上方移动。</div>
      <div class="text fontBig">使用笔和纸解决任务后，通过选择哪个状态属于图中的哪个节点来输入解决方案。（提示：每个状态恰好属于一个节点）。</div>
      <div class="text fontBig">对应于图11中的每个节点方框（1-6），从如图12所示的6个选项（A—F）中选择正确的状态。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/04-12.png" alt="">
      <div class="text fontBig" style="marginLeft:90px">1.你会将人工智能放在哪里？<input style="marginLeft:30px;" type="radio" v-model="chooseone" value="A" :disabled="isDisabled"><label>A</label><input style="marginLeft:15px;" type="radio" v-model="chooseone" value="B" :disabled="isDisabled"><label>B</label><input style="marginLeft:15px;" type="radio" v-model="chooseone" value="C" :disabled="isDisabled"><label>C</label><input style="marginLeft:15px;" type="radio" v-model="chooseone" value="D" :disabled="isDisabled"><label>D</label><input style="marginLeft:15px;" type="radio" v-model="chooseone" value="E" :disabled="isDisabled"><label>E</label></div>
      <div class="text fontBig" style="marginLeft:90px">2.你会将机器学习放在哪里？<input style="marginLeft:30px;" type="radio" v-model="choosetow" value="A" :disabled="isDisabled"><label>A</label><input style="marginLeft:15px;" type="radio" v-model="choosetow" value="B" :disabled="isDisabled"><label>B</label><input style="marginLeft:15px;" type="radio" v-model="choosetow" value="C" :disabled="isDisabled"><label>C</label><input style="marginLeft:15px;" type="radio" v-model="choosetow" value="D" :disabled="isDisabled"><label>D</label><input style="marginLeft:15px;" type="radio" v-model="choosetow" value="E" :disabled="isDisabled"><label>E</label></div>
      <div class="text fontBig" style="marginLeft:90px">3.你会将计算机科学放在哪里？<input style="marginLeft:15px;" type="radio" v-model="choosethree" value="A" :disabled="isDisabled"><label>A</label><input style="marginLeft:15px;" type="radio" v-model="choosethree" value="B" :disabled="isDisabled"><label>B</label><input style="marginLeft:15px;" type="radio" v-model="choosethree" value="C" :disabled="isDisabled"><label>C</label><input style="marginLeft:15px;" type="radio" v-model="choosethree" value="D" :disabled="isDisabled"><label>D</label><input style="marginLeft:15px;" type="radio" v-model="choosethree" value="E" :disabled="isDisabled"><label>E</label></div>
      <div class="text fontBig" style="marginLeft:90px">4.你会将数据科学放在哪里？<input style="marginLeft:30px;" type="radio" v-model="choosefour" value="A" :disabled="isDisabled"><label>A</label><input style="marginLeft:15px;" type="radio" v-model="choosefour" value="B" :disabled="isDisabled"><label>B</label><input style="marginLeft:15px;" type="radio" v-model="choosefour" value="C" :disabled="isDisabled"><label>C</label><input style="marginLeft:15px;" type="radio" v-model="choosefour" value="D" :disabled="isDisabled"><label>D</label><input style="marginLeft:15px;" type="radio" v-model="choosefour" value="E" :disabled="isDisabled"><label>E</label></div>
      <div class="text fontBig" style="marginLeft:90px">5.你会将深度学习放在哪里？<input style="marginLeft:30px;" type="radio" v-model="choosefive" value="A" :disabled="isDisabled"><label>A</label><input style="marginLeft:15px;" type="radio" v-model="choosefive" value="B" :disabled="isDisabled"><label>B</label><input style="marginLeft:15px;" type="radio" v-model="choosefive" value="C" :disabled="isDisabled"><label>C</label><input style="marginLeft:15px;" type="radio" v-model="choosefive" value="D" :disabled="isDisabled"><label>D</label><input style="marginLeft:15px;" type="radio" v-model="choosefive" value="E" :disabled="isDisabled"><label>E</label></div>
      <button class="sentBtn" style="marginLeft:290px;" @click="sentBtn">提交</button>
      <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      chooseone:'',
      choosetow:'',
      choosethree:'',
      choosefour:'',
      choosefive:'',
      choosesix:'',
      chooseseven:'',
      chooseeight:'',
      choosenine:'',
      chooseten:'',
      isDisabled:false,
      isDisabledOne:false,
      contenteditable:false,
    }
  },
  methods:{
    sentBtnOne(){
      this.contenteditable = true;
    },
    sentBtn(){
      this.isDisabled = true;
    },
    jumpOne(){
       const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
    jumpTow(){
      this.$router.push('/chapterFive');
    },
    jumpThree(){
      this.$router.push('/chapterSix');
    },
    goBlank(){
      this.$router.push('/chapterThree');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/chapterFive');
    },
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chapterOne{
    width: 650px;
    margin: 0 auto;
    padding: 0px 75px;
}
.text{
    text-indent:2em;
}
.fontBig{
    font-size: 16px;
    color: rgb(102, 102, 102);
    line-height: 30px;
    
}
.sentBtn{
  width: 100px;
  margin-left: 240px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
}
.anwser{
  width: 200px;
  height: 200px;
  border: 1px dashed black;
  margin-left: 230px;
  overflow:auto;
  font-size: 14px;
  outline: none;
  margin-top: 10px;
  padding: 10px;
}
.anwserInput{
  border: none;
  outline: none;
  border-bottom: 1px solid;
  font-size:16px;
}
.backBtn button{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/chapterFour.vue